import { useState } from "react";

import { CustomizedSwitches } from "view/components/CustomizedSwitches";

import TrashIcon from "assets/icons/HeroIcons/TrashIcon";
import Map from "./Map";

type QuestionElemet = {
  title?: string;
  name: string;
  isRequired: boolean;
  id: string;
  selectedShapes: any[];
  selectedLayers: any[];
  answer: any[];
  drawMultiple: boolean;
  description?: string;
  type: string;
  enableSnapping?: boolean;
  groupQuestionName?: string;
  questionId?: string;
};
interface I_DrawPolygon {
  editMode: boolean;
  element: QuestionElemet;
  answer: any[];
  setFieldValue: any;
  eleName: string;
  required?: boolean;
  error?: any;
  touched?: any;
  label?: string;
  panel?: any;
}

const DrawPolygon = ({
  editMode,
  element,
  answer,
  setFieldValue,
  eleName,
  required,
  error,
  touched,
  label,
  panel,
}: I_DrawPolygon) => {
  const [doShowMap, setDoShowMap] = useState(false);
  const [draw, setDraw] = useState<any>(null);

  // handlers
  const handleLayerNameInputOnChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    layerId: string
  ) => {
    const value = e.target.value;

    const updatedAnswers = answer.map((ans: any) => {
      if (ans.id === layerId) {
        ans.name = value;
      }
      return ans;
    });

    setFieldValue(eleName, updatedAnswers);
  };
  const handleClickOnLayerRemoveBtn = (layerId: string) => {
    const updatedAnswers = answer.filter((ans: any) => ans.id !== layerId);
    draw && draw.delete([layerId]);
    // console.log({shapes:draw.getAll(),layerId})
    setFieldValue(eleName, updatedAnswers);
  };

  return (
    <div
      className="p-4 rounded-lg dark:bg-bgtetriary bg-bgPrimaryLight"
      id={`${element?.questionId}`}
    >
      <div className="flex items-center justify-between text-textAnswer">
        <Name
          editMode={editMode}
          label={element.title}
          name={element.name}
          required={element.isRequired}
          drawMultiple={element.drawMultiple}
        />
        <div className="flex justify-end flex-1 basis-1/2">
          <CustomizedSwitches
            label="View map"
            onChange={(e: any) => setDoShowMap(e.target.checked)}
            labelClassName="text-secondary dark:text-caption"
          />
        </div>
      </div>
      <ListView list={answer} hideList={editMode} />
      {editMode && (
        <div className="flex flex-col w-full gap-2 px-3 py-6">
          {/* {answer?.length > 0 && (
            <h3 className="mb-1 text-base font-semibold text-textMid font-Overpass">
              Draw polygon
            </h3>
          )} */}

          {answer &&
            Array.isArray(answer) &&
            answer?.map((layer: any) => {
              return (
                <LayerEditBar
                  key={layer.id}
                  defaultValue={layer.name}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleLayerNameInputOnChange(e, layer.id)
                  }
                  onRemove={() => handleClickOnLayerRemoveBtn(layer.id)}
                />
              );
            })}
        </div>
      )}
      {doShowMap && (
        <Map
          answer={answer}
          element={element}
          eleName={eleName}
          setFieldValue={setFieldValue}
          editMode={editMode}
          setDraw={setDraw}
        />
      )}

      <Error error={error} />
    </div>
  );
};

export { DrawPolygon };

const Name = ({ editMode, label, name, required, drawMultiple }: any) => {
  return (
    <div>
      <p
        className={`w-full  text-md text-left capitalize font-Overpass ${
          editMode
            ? "text-primary dark:text-caption font-medium "
            : "text-primary dark:text-caption font-regular "
        }`}
      >
        {label || name} {required && <span>*</span>}
      </p>
      <p
        className={`w-full pb-1 text-xs text-left capitalize font-Overpass ${
          editMode
            ? "text-primary dark:text-caption font-medium "
            : "text-primary dark:text-caption font-regular "
        }`}
      >
        {drawMultiple
          ? "(NOTE: You can draw multiple shapes)"
          : "(NOTE: You can draw a single shape)"}
      </p>
    </div>
  );
};

const LayerEditBar = ({ defaultValue, onChange, onRemove }: any) => {
  return (
    <div className="flex w-full">
      <input
        className="flex-1 px-3 py-2 mr-4 text-base border rounded outline-none border-lineDark text-textNormal font-Overpass dark:text-caption "
        placeholder="Region name"
        defaultValue={defaultValue}
        onChange={onChange}
      />
      <button type="button" onClick={onRemove}>
        <TrashIcon />
      </button>
    </div>
  );
};

const Error = ({ error }: any) => {
  return (
    <div className="flex justify-start items-center self-stretch flex-grow-0 flex-shrink-0 relative py-0.5">
      {error && (
        <p className="flex-grow w-[1/2] text-xs text-left text-accent_1Dark">
          {error}
        </p>
      )}
    </div>
  );
};
const ListView = ({ list, hideList }: any) => {
  if (Array.isArray(list) && !hideList) {
    return (
      <ul className="pb-1 list-disc list-inside">
        {list.map((item: any, index: number) => {
          return (
            <li key={item.id} className="font-Overpass text-textAnswer">
              {item.name}
            </li>
          );
        })}
      </ul>
    );
  }
  return (
    !hideList && (
      <p className="text-textNoSelection font-normal font-Overpass text-[15px] italic">
        (No Selection)
      </p>
    )
  );
};
